export function Tab(props) {
    return <li {...props} />;
}
